import src from "IMAGE";
export default { src, width: 484, height: 330, blurWidth: 0, blurHeight: 0};
